import * as React from 'react';

import { CollapseContainer } from '../CollapseContainer';

export interface ICollapseHOC<T> {
  WrappedComponent: React.ComponentType<T>;
}

export function WithCollapse<T>({ WrappedComponent }: ICollapseHOC<T>) {
  //@ts-ignore

  // eslint-disable-next-line react/display-name
  return props => {
    const {
      isNewbuilding = false,
      isHidden = false,
      collapsed = true,
      header,
      headerClassName,
      contentClassName,
      blockType,
    } = props;

    if (isHidden) {
      return null;
    }

    if (isNewbuilding) {
      return (
        <CollapseContainer
          header={header}
          headerClassName={headerClassName}
          blockType={blockType}
          collapsed={collapsed}
        >
          <div className={contentClassName}>
            <WrappedComponent {...props} showHeader={false} />
          </div>
        </CollapseContainer>
      );
    }

    return <WrappedComponent {...props} showHeader={true} />;
  };
}

WithCollapse.dispayName = 'WithCollapse';
